import { useQuery } from '@tanstack/react-query';
import { getFiles, uploadPublicFile } from '@/lib/api/services/storage.service';
import { useGlobalMutation } from '@/state/query-client/hooks';

/** Public URL of an already-uploaded profile photo (`Employee.ProfileImageId` is a Blocks storage file id). */
export const useProfilePhotoUrl = (fileId?: string) =>
  useQuery({
    queryKey: ['hr-profile-photo-url', fileId],
    queryFn: async () => {
      const { data } = await getFiles([fileId as string]);
      return data?.[0]?.url ?? '';
    },
    enabled: Boolean(fileId),
    staleTime: 30 * 60 * 1000,
    throwOnError: false,
  });

/** Uploads a profile photo to Blocks storage; resolves with the new file id and its public URL. */
export const useUploadProfilePhoto = () =>
  useGlobalMutation({
    mutationFn: (file: File) => uploadPublicFile(file),
  });
